<template>
  <div class="reg_wrapper">
    <div class="container">
      <div class="main">
        <div class="breadcrumb">
          当前位置: <span @click="returnIndex"><a>首页</a></span> >
          <span>用户注册</span>
        </div>
        <div class="line"></div>
        <div class="lead">
          注册账号<span>(建议使用谷歌浏览器或QQ极速模式来填写该页面)</span>
        </div>
        <div class="reg reg-input reg-select">
          <div class="nav">
            <div class="title">账号信息</div>
          </div>
          <div class="line">
            <div></div>
          </div>

          <div class="form">
            <div class="row">
              <div class="label">
                <span style="color: red">* </span>我的角色
              </div>
              <div class="value">
                <el-radio-group v-model="role">
                  <el-radio v-for="item in options" :label="item.value" :key="item.value">{{ item.label }}</el-radio>
                </el-radio-group>
                <!--<el-select v-model="role" placeholder="请选择">-->
                <!--<el-option-->
                <!--v-for="item in options"-->
                <!--:key="item.value"-->
                <!--:label="item.label"-->
                <!--:value="item.value">-->
                <!--</el-option>-->
                <!--</el-select>-->
              </div>
            </div>
            <div class="row">
              <div class="label">
                <span style="color: red">* </span>手机号码
              </div>
              <div class="value">
                <el-input placeholder="请输入手机号码（作为登录系统的账号）" v-model="model.commobile" clearable></el-input>
              </div>
            </div>
            <!--<div class="row">-->
            <!--<div class="label">登录账号</div>-->
            <!--<div class="value">-->
            <!--<el-input  @blur="isExistCode" placeholder="请输入登录账号" v-model="model.usercode" clearable></el-input>-->
            <!--</div>-->
            <!--</div>-->
            <div class="row">
              <div class="label">
                <span style="color: red">* </span>登录密码
              </div>
              <div class="value">
                <el-input type="password" placeholder="请设置登录密码" v-model="model.userpassword" clearable></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">
                <span style="color: red">* </span>确认密码
              </div>
              <div class="value">
                <el-input type="password" placeholder="请再次输入密码" v-model="model.confirmpwd" clearable></el-input>
              </div>
            </div>
          </div>
          <div class="nav">
            <!--reg-radio-->
            <div class="title">单位信息</div>
            <!--<div  class="title"><el-radio @change="activeTab=0" v-model="radio" :label="0">单位注册账户信息</el-radio></div>-->
            <!--<div class="title"><el-radio @change="activeTab=1" v-model="radio" :label="1">个人注册账户信息</el-radio></div>-->
          </div>
          <div class="line" :class="{ active: activeTab === 1 }">
            <div></div>
            <!--<div class="radio"></div>-->
          </div>
          <div class="form" v-if="radio === 0">
            <!--<div class="row">-->
            <!--<div class="label">证件类型</div>-->
            <!--<div class="value">-->
            <!--<span>营业执照</span>-->
            <!--&lt;!&ndash;<el-select v-model="type" placeholder="证件类型">&ndash;&gt;-->
            <!--&lt;!&ndash;<el-option :key="1" label="营业执照" :value="1"></el-option>&ndash;&gt;-->
            <!--&lt;!&ndash;<el-option :key="2" label="身份证" :value="2"></el-option>&ndash;&gt;-->
            <!--&lt;!&ndash;</el-select>&ndash;&gt;-->
            <!--</div>-->
            <!--</div>-->
            <div class="row">
              <div class="label">
                <span style="color: red">* </span>单位名称
              </div>
              <div class="value">
                <el-input placeholder="请输入单位名称" :maxlength="80" v-model="model.comfullname" clearable></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">
                <span style="color: red">* </span>统一信用代码
              </div>
              <div class="value">
                <el-input placeholder="请输入统一信用代码" :maxlength="50" v-model="model.comidcode" clearable></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label"><span style="color: red">* </span>联系人</div>
              <div class="value">
                <el-input placeholder="请输入联系人" :maxlength="10" v-model="model.comcontact" clearable></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label"><span style="color: red">* </span>邮箱</div>
              <div class="value">
                <el-input placeholder="请输入邮箱" :maxlength="40" v-model="model.useremail" clearable></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">固定电话</div>
              <div class="value">
                <el-input placeholder="请输入固定电话" :maxlength="20" v-model="model.comtel" clearable></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">
                <span style="color: red">* </span>所在地区
              </div>
              <div class="value">
                <div class="area-select">
                  <area-select @changed="areaChanged" :_provinceId="model.pareaid" :_cityId="model.careaid"
                    :_areaId="model.comareaid"></area-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="label">
                <span style="color: red">* </span>详细地址
              </div>
              <div class="value">
                <el-input placeholder="请输入详细地址" :maxlength="255" v-model="model.comaddr" clearable></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">
                <span style="color: red">* </span>营业执照
              </div>
              <div class="value">
                <span>营业执照扫描件支持文件类型：jpg，jpeg，png</span>
              </div>
            </div>
            <div class="upload">
              <upload-pic-one @changed="setPic" :picUrl="model.appendurl" folderName="obweb" text="选择文件">
              </upload-pic-one>
            </div>
          </div>
          <div class="form" v-if="radio === 1">
            <div class="row">
              <div class="label"><span style="color: red">* </span>姓名</div>
              <div class="value">
                <el-input @blur="isExistComName(2)" placeholder="请输入姓名" v-model="model.comcontact" clearable></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">证件类型</div>
              <div class="value">
                <span>身份证</span>
                <!--<el-select v-model="type" placeholder="证件类型">-->
                <!--<el-option :key="1" label="营业执照" :value="1"></el-option>-->
                <!--<el-option :key="2" label="身份证" :value="2"></el-option>-->
                <!--</el-select>-->
              </div>
            </div>
            <div class="row">
              <div class="label">
                <span style="color: red">* </span>身份证号码
              </div>
              <div class="value">
                <el-input @blur="isExistComName(3)" placeholder="请输入身份证号码" v-model="model.comidcode" clearable>
                </el-input>
              </div>
            </div>
            <!--<div class="row">-->
            <!--<div class="label">联系电话</div>-->
            <!--<div class="value">-->
            <!--<el-input placeholder="请输入联系电话" v-model="model.comtel" clearable></el-input>-->
            <!--</div>-->
            <!--</div>-->
            <div class="row">
              <div class="label">所在地区</div>
              <div class="value">
                <div>
                  <area-select @changed="areaChanged" :_provinceId="model.pareaid" :_cityId="model.careaid"
                    :_areaId="model.comareaid"></area-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="label">详细地址</div>
              <div class="value">
                <el-input placeholder="请输入详细地址" v-model="model.comaddr" clearable></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">
                <span style="color: red">* </span>身份证证件
              </div>
              <div class="value">
                <span>身份证扫描件支持文件类型：jpg，jpeg，png</span>
              </div>
            </div>
            <div class="upload">
              <upload-pic-one @changed="setPic" :picUrl="model.appendurl" folderName="obweb" text="选择文件">
              </upload-pic-one>
            </div>
          </div>
          <div class="form">
            <div class="row yzm">
              <div class="label"><span style="color: red">* </span>验证码</div>
              <div class="value yzm-input">
                <el-input placeholder="请输入短信验证码" v-model="model.yzm" clearable></el-input>
              </div>
              <div class="yzmbtn" @click="getsms">
                <sec-count-down v-if="sendFlag" @stop="stop">秒后获取</sec-count-down>
                <span v-else>发送验证码</span>
              </div>
            </div>
            <div class="row">
              <div class="label"></div>
              <div class="value">
                <el-checkbox v-model="cosagreement"></el-checkbox><span class="agree" @click="toLink"> 同意《注册协议》</span>
              </div>
            </div>
          </div>

          <a>
            <div class="btn" @click="submit">提交注册信息</div>
            <!--<div class="btn" @click="submit" v-else>激活</div>-->
          </a>
        </div>
      </div>
    </div>
    <el-dialog title="注册协议" :close-on-click-modal="false" @close="dialogclose" :visible.sync="dialogVisible"
      width="60%">
      <div class="agreementcontent">
        <div v-html="cos.cosagreement"></div>
        <div class="btn">
          <el-button @click="dialogVisible = false">我已阅读</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UploadPicOne from "../components/common/UploadPicOne";
import SecCountDown from "../components/common/SecCountDown";
import AreaSelect from "../components/common/AreaSelect.vue";
import common from "@/mixin/common";
import request from "@/utils/request";
import Regular from "../assets/js/regular";
export default {
  name: "reg.vue",
  mixins: [common],
  components: { UploadPicOne, SecCountDown, AreaSelect },
  data() {
    return {
      dialogVisible: false,
      cosagreement: false,
      activeTab: 0,
      role: "3",
      type: "",
      radio: 0,
      com: "",
      // cos: {},
      model: {
        yzm: "",
        comid: 0,
        pareaid: "",
        careaid: "",
        comareaid: "",
        comfullname: "",
        commobile: "",
        comemail: "",
        comzipcode: "",
        comwebaddr: "",
        comremark: "",
        comcontact: "",
        comtype: "",
        comtel: "",
        comfromflg: 1,
        comstatus: 2,
        comaddr: "",
        comidtype: "",
        comidcode: "",
        usercode: "",
        userpassword: "",
        confirmpwd: "",
        appendurl: "",
        appendfilename: "",
        append: "",
        yzmToken: "",
      },
      // , { "label": "采购人", "value": "2"}
      options: [{ label: "供应商", value: "3" }],
      errMsg: "",
      sendFlag: false,
      isDisabledBtn: false,
      isReg: true,
    };
  },
  mounted() {
    // this.getSysCodeList()
  },
  methods: {
    async getCosModel() {
      // let res = await request({
      //   method: 'get',
      //   url: '/web/web/getWebCosList',
      //   params: {cosflg: 1}
      // })
      // this.cos = res.length ? res[0] : {}
    },
    async toLink() {
      await this.getCosModel();
      this.dialogVisible = true;
      // this.$router.push({path: '/agreement'})
    },
    returnIndex() {
      this.$router.replace({ path: "/" });
    },
    validate() {
      this.errMsg = "";
      var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z!@+-=#*$%_]{8,}$/;
      var telphone = Regular.GetRegularExpression("telphone");
      var cardid = Regular.GetRegularExpression("cardid");
      if (!this.role) {
        this.errMsg = "请选择我的角色!";
      } else if (this.model.userpassword === "") {
        this.errMsg = "请输入新密码!";
      } else if (!reg.test(this.model.userpassword)) {
        this.errMsg = "新密码要求是数字和字符的结合，不能少于8位数!";
      } else if (this.model.confirmpwd === "") {
        this.errMsg = "请输入确认密码!";
      } else if (this.model.confirmpwd !== this.model.userpassword) {
        this.errMsg = "两次密码输入的不一致!";
      } else if (!this.model.commobile) {
        this.errMsg = "请输入手机号码!";
      } else if (!telphone.test(this.model.commobile)) {
        this.errMsg = "手机号码格式不正确!";
      } else if (this.radio === 0 && !this.model.comfullname) {
        this.errMsg = "请输入单位名称!";
      } else if (this.comaddr === "") {
        this.errMsg = "请输入详细地址!";
      }
      else if (!this.model.comidcode) {
        this.errMsg =
          this.radio === 0 ? "请输入统一信用代码!" : "请输入身份证号码";
      } else if (this.radio === 1 && !cardid.test(this.model.comidcode)) {
        this.errMsg = "请输入正确的身份证号码!";
      } else if (!this.model.comcontact) {
        this.errMsg = this.radio === 0 ? "请输入联系人！" : "请输入姓名";
      } else if (!this.model.useremail) {
        this.errMsg = "请输入邮箱";
      } else if (
        !this.model.pareaid ||
        !this.model.careaid ||
        !this.model.comareaid
      ) {
        this.errMsg = "请选择地区";
      } else if (this.model.appendurl === "") {
        this.errMsg = "请上传营业执照!";
      } else if (this.model.yzm === "") {
        this.errMsg = "请输入验证码!";
      }
    },
    validate2() {
      var reg = Regular.GetRegularExpression("telphone");
      if (!this.model.commobile) {
        this.errMsg = "请输入手机号码!";
      } else if (!reg.test(this.model.commobile)) {
        this.errMsg = "手机号码格式不正确！";
      } else {
        this.errMsg = "";
      }
    },
    areaChanged(data) {
      if (data && data.provinceId) {
        // 省
        this.model.pareaid = data.provinceId;
        // 市
        this.model.careaid = data.cityId;
        // 区
        this.model.comareaid = data.areaId;
      }
    },
    async isExistCode() {
      let userData = await request({
        url: "/web/web/isExistCode",
        method: "get",
        params: { usercode: this.model.usercode },
      });
      if (userData) {
        this.model.usercode = "";
        this.$message({
          message: "该登录账号已存在！",
          type: "warning",
        });
        return;
      }
    },
    async isExistComName() {
      if (
        (this.radio === 1 && this.model.comcontact && this.model.comidcode) ||
        (this.radio === 0 && this.model.comidcode)
      ) {
        let userData = await request({
          url: "/web/web/isExistComName",
          method: "get",
          params: {
            comfullname:
              this.radio === 0 ? this.model.comfullname : this.model.comcontact,
            comidcode: this.model.comidcode,
          },
        });
        if (userData.data) {
          // this.isReg = true
          // this.model.comfullname = ''
          // this.model.comcontact = ''
          // this.model.comidcode = ''
          // if (type === 2) {
          //   this.model.comcontact = ''
          // } else if (type === 3) {
          //   this.model.comidcode = ''
          // }
          if (this.radio === 0) {
            this.$confirm(
              `该单位名称已存在，点击找回单位找回登录账号?`,
              "提示",
              {
                confirmButtonText: "找回注册",
                cancelButtonText: "继续注册",
                type: "warning",
              }
            )
              .then(() => {
                let com = {
                  comfullname: this.model.comfullname,
                  comidcode: this.model.comidcode,
                };
                this.$router.push({ name: "findCom", params: { com: com } });
              })
              .catch(() => {
                this.model.comfullname = "";
                this.model.comcontact = "";
                this.model.comidcode = "";
              });
          } else {
            this.$message({
              message: "用户已存在",
              type: "warning",
            });
          }
          return;
        }
      }
    },
    async getsms() {
      this.validate2();
      if (this.errMsg !== "") {
        this.$message({
          message: this.errMsg,
          type: "warning",
        });
        return;
      }
      // let userData = await request({
      //   url: '/web/web/isExistMobile',
      //   method: 'get',
      //   params: {usermobile: this.model.commobile, userstatus: 1}
      // })
      // if (userData) {
      //   this.$message({
      //     message: '该手机号码已存在！',
      //     type: "warning"
      //   })
      //   return
      // }
      if (this.isDisabledBtn) {
        return;
      }
      let res = await request({
        url: "/sms/send",
        method: "get",
        params: { type: "1", tel: this.model.commobile },
      });
      this.sendFlag = true;
      this.isDisabledBtn = true;
      this.model.yzmToken = res.data;
      if (res.issuccess) {
        this.$message.success("验证码获取成功");
        this.isDisabledBtn = true;
        this.sendFlag = true;
      } else {
        this.isDisabledBtn = false;
        this.sendFlag = false;
        this.$message({
          message: "获取验证码失败，请30秒后再重新获取",
          type: "warning",
        });
      }
    },
    async getSysCodeList() {
      let res = await request({
        method: "get",
        url: "/web/web/getSysCodeList",
        params: { syscode: "cositemcomtype" },
      });
      let index = res.findIndex((v) => v.syscodeval === "4");
      res.splice(index, 1);
      index = res.findIndex((v) => v.syscodeval === "5");
      res.splice(index, 1);
      index = res.findIndex((v) => v.syscodeval === "1");
      res.splice(index, 1);
      index = res.findIndex((v) => v.syscodeval === "6");
      res.splice(index, 1);
      index = res.findIndex((v) => v.syscodeval === "7");
      res.splice(index, 1);
      this.options = res;
    },
    async submit() {
      this.validate();
      if (this.errMsg !== "") {
        this.$message({
          message: this.errMsg,
          type: "warning",
        });
        return;
      }
      if (!this.cosagreement) {
        this.$message({
          message: "请阅读注册协议并勾选同意《注册协议》后提交注册信息",
          type: "warning",
        });
        return;
      }
      this.model.cosid = this.cosId;
      if (this.radio === 1) {
        this.model.comfullname = this.model.comcontact;
        this.model.comtel = this.model.commobile;
      }
      this.model.usercode = this.model.commobile;
      this.model.comtype = this.role;
      this.model.comidtype = this.type;
      this.model.comfullname = this.model.comfullname.replaceAll(" ", "");
      this.model.comidcode = this.model.comidcode.replaceAll(" ", "");
      // this.model.comname = this.model.comfullname

      if (this.model.appendurl) {
        this.model.append = {
          appendfromid: "",
          appendfromtype: 1,
          appendtype: 1,
          appendseq: 1,
          appendfilecode: "",
          appendurl: this.model.appendurl,
          appendfilename: this.model.appendfilename,
          appendremark: "",
        };
      }
      // if (this.com) {
      //   this.model.comid = this.com.comid
      //   this.model.comstatus = 2
      // }
      let data = await request({
        url: "/web/web/reg",
        method: "post",
        data: this.model,
      });
      if (data == "findcom") {
        this.$confirm(`该单位已存在，点击“找回注册”找回登录账号?`, "提示", {
          confirmButtonText: "找回注册",
          cancelButtonText: "继续注册",
          type: "warning",
        })
          .then(() => {
            let com = {
              comfullname: this.model.comfullname,
              comidcode: this.model.comidcode,
            };
            this.$router.push({ name: "findCom", params: { com: com } });
          })
          .catch(() => {
            this.model.comfullname = "";
            this.model.comcontact = "";
            this.model.comidcode = "";
          });
      } else if (data === "exist") {
        this.$message.warning("该手机号码已存在！");
      } else {
        if (data.issuccess === 1) {
          this.$message.success("注册成功");
          this.pushNotice();
          this.$router.push({ path: "/login" });
        } else {
          this.$message.error("注册失败");
          this.isDisabledBtn = false;
        }
      }
    },
    async pushNotice() {
      let model = {};
      model.cosid = this.cosId;
      model.comname = this.model.comfullname;
      model.tel = this.model.commobile;
      model.username = this.model.comcontact;
      await request({
        url: "/web/web/regPush",
        method: "post",
        data: model,
      });
    },
    stop() {
      this.sendFlag = false;
      this.isDisabledBtn = false;
    },
    setPic(val, name) {
      this.model.appendurl = val;
      this.model.appendfilename = name;
    },
    dialogclose() {
      this.dialogVisible = false;
    },
  },
  computed: {
    ...mapGetters(["cosId", "cos"]),
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1201px) {
  @import "../styles/variables.scss";

  .reg_wrapper {
    .agreementcontent {
      display: flex;
      flex-direction: column;
      align-items: center;

      .btn {
        padding-top: 20px;
      }
    }

    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;

      .main {
        margin-top: 38px;
        padding: 23px 20px 100px;
        width: 1201px;
        background-color: $color-bg-white;
 
        .line {
          height: 2px;
          border-bottom: 1px solid #eaeaea;
          margin-bottom: 32px;

          div {
            border-bottom: 3px solid $color-orange;
            width: 65px;
          }

          .radio {
            border-bottom: 3px solid $color-orange;
            width: 155px;
          }
        }

        .active {
          div {
            border-bottom: 3px solid $color-orange;
            margin-left: 205px;
            width: 85px;
          }
        }

        .breadcrumb {
          font-size: $fontsize-medium;
          color: $color-text-secondary-gray;
          padding-bottom: 10px;

          > :first-child {
            padding-left: 10px;

            a:hover {
              color: $color-orange;
            }
          }
        }

        .lead {
          border-left: 4px solid $color-orange;
          font-weight: bold;
          font-size: $fontsize-large-x;
          margin: 40px 0 0px;
          padding-left: 10px;
          display: flex;
          align-items: center;

          span {
            font-weight: normal;
            font-size: $fontsize-medium;
            color: $color-text-secondary-gray;
          }
        }

        .reg {
          padding-left: 14px;

          .nav {
            display: flex;
            padding-top: 60px;

            .title {
              cursor: pointer;
              margin-right: 50px;
              padding-bottom: 18px;
              font-weight: bold;
              font-size: $fontsize-large;
            }
          }

          .form {
            font-size: $fontsize-medium;

            /*padding: 32px 0 0px;*/
            .row {
              display: flex;
              align-items: center;
              padding: 10px 0;
              width: 448px;

              .label {
                text-align: right;
                width: 110px;
                margin-right: 10px;
              }

              .value {
                flex: 1;

                span {
                  color: $color-text-secondary-gray;
                }

                .agree {
                  padding-left: 5px;
                  cursor: pointer;
                  color: #0888ff;
                  // text-decoration: underline;
                }
              }

              .yzmbtn {
                cursor: pointer;
                border: 1px solid $color-orange;
                padding: 11px;
                margin-left: 10px;
                color: $color-orange;
              }

              .agreement {
                width: 318px;
                margin-left: 130px;
              }
            }

            .upload {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-left: 140px;
              width: 158px;
              height: 118px;
              border: 1px solid #dcdfe6;
            }
          }

          .btn {
            margin-top: 60px;
            width: 318px;
            margin-left: 130px;
            text-align: center;
            background-color: $color-orange;
            padding: 15px;
            font-size: $fontsize-large-x;
            color: #fff;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) and (min-width: 769px) {
  .content {
    margin: auto;

    .reg_wrapper {
      .container {
        .main {
          .breadcrumb {
            margin: 2em 0;
            font-size: 14px;
            color: #999999;
          }

          .line {}

          .lead {
            display: none;
          }

          .reg {
            .nav {
              .title {
                width: 65px;
                margin-bottom: 10px;
                margin-left: 10px;
                padding-bottom: 5px;
                font-weight: bold;
                border-bottom: 2px solid #f46722;
              }
            }

            .line {}

            .form {
              .row {
                display: flex;
                align-items: center;
                margin: 10px 0;

                .label {
                  width: 6em;
                  text-align: right;
                  padding-right: 0.6em;
                }

                .value {
                  .area-select {
                    width: 11em;
                  }

                  span {
                    font-size: 13px;
                  }

                  .radiogroup {}
                }

                .yzm-input {
                  width: 10.6em;
                }

                .yzmbtn {
                  font-size: .6em;
                  border: 1px dotted #F46722;
                  color: #F46722;
                  padding: 1em;
                  margin-left: 1em;
                }

                .agree {
                  color: #0888ff;
                }
              }

              .upload {
                margin-left: 94px;
              }
            }

            .btn {
              width: 320px;
              background-color: #F46722;
              color: #fff;
              text-align: center;
              height: 3em;
              line-height: 3em;
              margin: .5em 2em;
            }
          }
        }
      }
    }
  }

  .l-AreaSelect[data-v-182fe84d] {
    display: block;
  }
}

@media screen and (max-width: 768px) {
  .content {
    margin: auto;

    .reg_wrapper {
      .container {
        .main {
          .breadcrumb {
            margin: 2em 0;
            font-size: 14px;
            color: #999999;
          }

          .line {}

          .lead {
            display: none;
          }

          .reg {
            .nav {
              .title {
                width: 65px;
                margin-bottom: 10px;
                margin-left: 10px;
                padding-bottom: 5px;
                font-weight: bold;
                border-bottom: 2px solid #f46722;
              }
            }

            .line {}

            .form {
              .row {
                display: flex;
                align-items: center;
                margin: 10px 0;

                .label {
                  width: 6em;
                  text-align: right;
                  padding-right: 0.6em;
                }

                .value {
                  .area-select {
                    width: 11em;
                  }

                  span {
                    font-size: 13px;
                  }

                  .radiogroup {}
                }

                .yzm-input {
                  width: 10.6em;
                }

                .yzmbtn {
                  font-size: .6em;
                  border: 1px dotted #F46722;
                  color: #F46722;
                  padding: 1em;
                  margin-left: 1em;
                }

                .agree {
                  color: #0888ff;
                }
              }

              .upload {
                margin-left: 94px;
              }
            }

            .btn {
              background-color: #F46722;
              color: #fff;
              text-align: center;
              height: 3em;
              line-height: 3em;
              margin: .5em 2em;
            }
          }
        }
      }
    }
  }

  .l-AreaSelect[data-v-182fe84d] {
    display: block;
  }
}
</style>
